// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-collection-filters {
  display: flex;
  align-items: center;
}
.dl-collection-filters_compact-mode {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.dl-collection-filters_compact-mode .dl-collection-filters__filters-block {
  width: 100%;
  margin-top: 8px;
}
.dl-collection-filters_compact-mode .dl-collection-filters__filter-by-type {
  margin-left: 0;
}
.dl-collection-filters_compact-mode .dl-collection-filters__sort {
  flex: 1;
}
.dl-collection-filters__filters-block {
  display: flex;
  align-items: center;
}
.dl-collection-filters__filter-string-container {
  width: 100%;
  display: flex;
}
.dl-collection-filters__filter-string {
  flex: 1;
}
.dl-collection-filters__filter-by-type {
  margin-left: 8px;
  min-width: 150px;
}
.dl-collection-filters__sort {
  margin-left: 8px;
  min-width: 220px;
}
.dl-collection-filters__radio-button {
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/CollectionFilters/CollectionFilters.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;AADJ;AAGI;EACI,sBAAA;EACA,uBAAA;EACA,uBAAA;AADR;AAGQ;EACI,WAAA;EACA,eAAA;AADZ;AAIQ;EACI,cAAA;AAFZ;AAKQ;EACI,OAAA;AAHZ;AAOI;EACI,aAAA;EACA,mBAAA;AALR;AAQI;EACI,WAAA;EACA,aAAA;AANR;AASI;EACI,OAAA;AAPR;AAUI;EACI,gBAAA;EACA,gBAAA;AARR;AAWI;EACI,gBAAA;EACA,gBAAA;AATR;AAYI;EACI,gBAAA;AAVR","sourcesContent":[".dl-collection-filters {\n  display: flex;\n  align-items: center;\n}\n.dl-collection-filters_compact-mode {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.dl-collection-filters_compact-mode .dl-collection-filters__filters-block {\n  width: 100%;\n  margin-top: 8px;\n}\n.dl-collection-filters_compact-mode .dl-collection-filters__filter-by-type {\n  margin-left: 0;\n}\n.dl-collection-filters_compact-mode .dl-collection-filters__sort {\n  flex: 1;\n}\n.dl-collection-filters__filters-block {\n  display: flex;\n  align-items: center;\n}\n.dl-collection-filters__filter-string-container {\n  width: 100%;\n  display: flex;\n}\n.dl-collection-filters__filter-string {\n  flex: 1;\n}\n.dl-collection-filters__filter-by-type {\n  margin-left: 8px;\n  min-width: 150px;\n}\n.dl-collection-filters__sort {\n  margin-left: 8px;\n  min-width: 220px;\n}\n.dl-collection-filters__radio-button {\n  margin-left: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
